import { IS_MOBILE_APP_QUERY } from '@gig/magic-messages';
import VueRouter from 'vue-router';
import { RouteName } from '../../../routes/routes.constants';
import {
    MobileAppMessageTypes,
    MobileAppNativeRoutes,
} from '@gig/magic-frontend-toolkit';

export async function initMobileAppRoutingGuard(router: VueRouter) {
    const isMobileApp: boolean =
        (await window.queryBus.query<boolean>(IS_MOBILE_APP_QUERY)) ?? false;

    router.beforeResolve((to, from, next) => {
        if (isMobileApp && to.name === RouteName.SIGN_UP) {
            window.eventBus.publish(
                MobileAppMessageTypes.NAVIGATE_TO_FROM_WEBVIEW,
                { route: MobileAppNativeRoutes.SIGN_UP_SCREEN },
            );

            return next(from.name ? false : '/');
        }

        next();
    });
}
